import { parseSpreadsheetFail, parseSpreadsheetSuccess } from '@cobliteam/store/src/HOR/Spreadsheet/actionCreators';
import type { ParseSpreadsheetStart } from '@cobliteam/store/src/HOR/Spreadsheet/actions';
import { call, put } from 'redux-saga/effects';
import { toast } from 'sonner';
import { Spreadsheet } from './parser/Spreadsheet';
import type { GenericSheet } from './parser/types';

/**
 * Converts a plain File type to a ArrayBuffer, to be used by parsers
 * @method fileToArrayBuffer
 * @param  file              A File object
 * @return                   An Array Buffer
 */
export function fileToArrayBuffer(file: File): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result && reader.result instanceof ArrayBuffer) {
        resolve(reader.result);
      }
      const error = new Error('Failed to transform File to ArrayBuffer');
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}

export function* parseSpreadsheet(action: ParseSpreadsheetStart) {
  const file = action.payload;

  try {
    const sheetArrayBuffer: ArrayBuffer = yield call(fileToArrayBuffer, file);

    const spreadsheet = new Spreadsheet(sheetArrayBuffer, 'array', undefined, false);

    const sheet: GenericSheet = yield call(spreadsheet.getParsedSheet);

    yield put(parseSpreadsheetSuccess(action.domain, sheet));
  } catch (err) {
    yield put(parseSpreadsheetFail(action.domain));
    toast.error('Problema ao processar a planilha');
  }
}
